import React from "react";
import "./Home.css";
import Dashboard from "./Dashboard";

export default function App() {
    return (
    <>
        <Dashboard/>
    </>
    );
}  